import type { Member } from '@/features/iam/members/Member'

/**
 * Thrown when saving a legend version failed because someone else saved it
 * since it was loaded.
 */
export class LegendConflictError extends Error {
  constructor(
    readonly lastUpdatedBy: Member,
    cause: unknown,
  ) {
    super('Someone else changed the legend since it was loaded.', { cause })
    this.name = 'LegendConflictError'
  }
}
